
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.25 12a7.75 7.75 0 1115.5 0 7.75 7.75 0 01-15.5 0zM12 2.75a9.25 9.25 0 100 18.5 9.25 9.25 0 000-18.5zm.75 4.528a.75.75 0 00-1.5 0V12c0 .199.079.39.22.53l2.833 2.834a.75.75 0 001.06-1.061l-2.613-2.614V7.278z"}})])
          )
        }
      }
    